import { IApiError } from '@/models/apiError.model';
import { IOrder } from '@/models/order.model';
import { IPagination } from '@/models/pagination.model';
import { TOrderFiltersValues } from '../helpers';

export const ORDERS_SLICE_NAME = 'orders';

export interface OrdersState {
  order: IOrder | null;
  orders: IOrder[] | null;
  appliedFilters: TOrderFiltersValues | null;
  pagination: IPagination | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: OrdersState = {
  pagination: null,
  order: null,
  orders: null,
  appliedFilters: null,
  isLoading: false,
  error: null,
};
